import React from 'react';

const ArtistSwitchingLoader: React.FC = () => {
  return (
    <div className="fixed inset-0 z-[100000] bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-8 flex flex-col items-center gap-4 shadow-2xl">
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-blue-600 rounded-full border-t-transparent animate-spin"></div>
        </div>
        <p className="text-gray-700 font-medium text-lg">Switching artist...</p>
        <p className="text-gray-500 text-sm">Loading data for selected artist</p>
      </div>
    </div>
  );
};

export default ArtistSwitchingLoader;

